var product = {

  firstLoad: true,
  helpers: null,

  preInit: function () {
    // continue
    product.init();
    // variants
    product.helpers = product.variants();
  },

  init: function () {

    $('.m-product:not(.js-product-done)').each(function () {
      var wrapper = $(this);
      var productData = $.parseJSON($('script#jsProductData').html())[0].Data;

      // set guid
      wrapper.find('#jsProductGuid').val(productData.Guid);

      // gallery 
      product.gallery(wrapper, productData.ImageModels);

      // compatibility
      var processing = false;
      $('a.js-popup-compatibility').off('click').on('click', function () {
        // stop multiple clicks
        if (processing) {
          return false;
        }

        var variant = getCurrentVariant();

        var button = $(this);
        var originalButtonText = button.html();

        function beginProcessing(button) {
          processing = true;
          button.html("Please wait...");
        }

        function endProcessing(button) {
          processing = false;
          button.html(originalButtonText);
        }

        beginProcessing(button);

        // get the compatibility data
        $.ajax({
          url: '/product/json/' + variant.Name + '/compatibility/',
          type: 'GET',
          data: { selected: variant.Guid },
          cache: false,
          success: function (responseData) {
            endProcessing(button);
            if (responseData.success) {
              if (responseData.data != null && responseData.data.length > 0) {
                popups.productCompatibility(responseData.data);
              }
              else {
                popups.confirm('No Vehicles', 'Sorry there are no vehicles this part fits', '', true);
              }
            }
            else {
              displayFailure();
            }
          },
          error: function () {
            endProcessing(button);
            displayFailure();
          }
        });

        return false;
      });

      // deliveryInfo
      product.deliveryInfo();

      // helper functions
      function displayFailure() {
        popups.confirm('Error', 'Sorry, there was a problem retrieving the products that this part fits. Please try again.', '', true);
      }

      function getCurrentVariant() {
        if (!product.helpers.hasVariants) return productData;

        var currentSelection = product.helpers.getCurrentSelection();
        var selectedVariant = product.helpers.variantMatchingSelection(currentSelection);

        if (product.helpers.defined(selectedVariant)) {
          return selectedVariant.Data;
        }
        else {
          return productData;
        }
      }

      // done
      wrapper.addClass('js-product-done');
    });

  },

  gallery: function (p, data) {

    p.find('.m-product__gallery .js-product-gallery-group:not(.js-gallery-done)').each(function () {
      var wrapper = $(this);
      var gallery = wrapper.find('.js-gallery');
      var pager = wrapper.find('.js-pager');
      var imageSlider, pagerSlider, i;

      // load additional images & pager
      if (data != null && data.length > 1) {
        var tmpImage = $('#productGalleryImageTemplate').html();
        tmpImage = Hogan.compile(tmpImage);

        var tmpPager = $('#productGalleryPagerTemplate').html();
        tmpPager = Hogan.compile(tmpPager);

        // clear existing items
        gallery.empty();
        pager.empty();

        // append new items
        for (i = 0; i < data.length; i++) {
          var item = data[i];
          gallery.append(tmpImage.render(item));
          pager.append(tmpPager.render(item));
        }

        // image slider functionality
        var slides = gallery.find('.js-slide');
        if (slides.length > 1) {
          imageSlider = gallery.bxSlider({
            mode: 'fade',
            pagerCustom: '#jsGalleryPager',
            speed: 500,
            infiniteLoop: false,
            hideControlOnEnd: true
          });
        }

        // pager slider functionality
        slides = pager.find('.js-item');
        if (slides.length > 1) {
          pagerSlider = pager.bxSlider({
            pager: false,
            speed: 500,
            minSlides: 2,
            maxSlides: 5,
            moveSlides: 2,
            slideWidth: 123,
            slideMargin: 10,
            infiniteLoop: false,
            hideControlOnEnd: true
          });
        }

        // trigger ajax
        $(document).trigger('ajaxComplete');
      }

      // done
      wrapper.addClass('js-gallery-done');
    });
  },

  variants: function () {

    if (!$('.js-product-variants').length) return { hasVariants: false };

    var data = $.parseJSON($('#jsProductVariants').html());
    var baseProductData = $.parseJSON($('#jsBaseProductData').html());
    var variants = $('.js-product-variants .js-product-variant');
    var sharedata = $.parseJSON($('#jsShareData').html());

    var _changeContent = function (content, keyValues) {

      var _replaceContent = function (templateId, itemToReplace, newContent) {
        var template = Mustache.render($(templateId).html(), newContent);
        itemToReplace.html(template);
      };

      var _replaceGallery = function (newContent, images) {
        var template = Hogan.compile($('#productGalleryTemplate').html());
        $('.js-product-gallery-replace').empty().html(template.render(newContent));
        product.gallery($('#jsProduct'), images, null);
      };

      var _replaceShare = function (newContent) {
        var template = Hogan.compile($('#shareTemplate').html());
        var handle = $('.js-product-share-replace .m-share').attr('data-handle');
        var image = defined(newContent.ImageModels[0]) ? newContent.ImageModels[0].MediaPath : null;
        $('.js-product-share-replace').html(template.render({
          EncodedTitle: encodeURIComponent(newContent.DisplayName),
          EncodedUrl: encodeURIComponent(location.protocol + '//' + location.hostname + newContent.Url),
          EncodedImage: encodeURIComponent(location.protocol + '//' + location.hostname + image),
          Handle: handle,
          HandleFormatted: handle.replace('@', ''),
          HasImage: image != null,
          FacebookSVG: sharedata.Data.FacebookSVG,
          XSVG: sharedata.Data.XSVG,
          PintrestSVG: sharedata.Data.PintrestSVG,
          PrintSVG: sharedata.Data.PrintSVG,

        }));
      };

      // show loader
      popups.loader();

      // replace title
      $('.js-product-title-replace').html(content.DisplayName);

      // replace price
      _replaceContent('#productPriceTemplate', $('.js-product-price-replace'), content.PricingModel);

      // replace stock
      _replaceContent('#productStockTemplate', $('.js-product-stock-replace'), content.StockModel);

      // replace add
      _replaceContent('#productAddTemplate', $('.js-product-add-replace'), content.PricingModel);

      // replace bundle
      _replaceContent('#productBundleTemplate', $('.js-product-bundle-replace'), content);

      // replace product guid
      $('#jsProductGuid').val(content.Guid);

      // replace gallery
      _replaceGallery(content.GalleryModel, content.ImageModels);

      // replace description
      _replaceContent('#productDescriptionTemplate', $('.js-product-description-replace'), content.DescriptionModel);

      // replace spec
      _replaceContent('#productSpecTemplate', $('.js-product-spec-replace'), content.SpecificationModel);
      _replaceContent('#productSpecHiddenTemplate', $('.js-product-spec-hidden-replace'), content.SpecificationModel);

      // replace essential extras
      _replaceContent('#productEssentialExtrasTemplate', $('.js-product-ee-replace'), content.EssentialExtrasModel);

      // replace share
      _replaceShare(content);

      // replace history url (if browser supports it)
      if (history.replaceState) {
        history.replaceState(content, document.title, content.Url);
      }

      product.deliveryInfo();

      $('.js-product-add-replace').removeClass('m-product__add--js-hide');

      // ajax
      $(document).trigger('ajaxComplete');

      // hide loader
      popups.loader(true);
    };

    updateView();

    var _update = function (key, value) {
      updateOptions(availableValuesForSelection(key, value));

      updateView();
    };

    function availableValuesForSelection(changedKey, changedValue) {
      var keys = allKeys();
      var availableValues = [];
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var availableValuesForKey = [''];
        for (var j = 0; j < data.length; j++) {
          var variant = data[j];
          if (!defined(changedValue) || isChangedKey(key) || variantMatchesSelection(variant)) {
            availableValuesForKey.push(variant.VariantKeyValues[key]);
          }
        }
        availableValues.push({
          key: key,
          value: availableValuesForKey
        });
      }
      return availableValues;

      function isChangedKey(key) {
        return key === changedKey;
      }

      function variantMatchesSelection(variant) {
        return variant.VariantKeyValues[changedKey] === changedValue;
      }
    }

    function updateOptions(availableValues) {
      variants.each(function () {
        var input = $(this);
        var options = input.find('option');
        var key = input.attr('data-key');
        var values = availableValuesForKey(key);

        options.addClass('unavailable');
        for (var i = 0; i < values.length; i++) {
          options.filter('[value="' + values[i] + '"]').removeClass('unavailable');
        }

        if (input.is('[data-swatch]')) {
          forms.swatch.update(input);
        }
      });

      function availableValuesForKey(key) {
        var keyValue = firstOrDefault(availableValues, function (kv) {
          return kv.key === key;
        });
        if (!defined(keyValue)) {
          if (defined(console)) {
            console.log("[Error] No values available for key: " + key);
          }
          return [];
        }
        return keyValue.value;
      }
    }

    function updateView() {
      var currentSelection = getCurrentSelection();
      var selectedVariant = variantMatchingSelection(currentSelection);
      if (defined(selectedVariant)) {
        _changeContent(selectedVariant.Data, selectedVariant.VariantKeyValues);
      } else {
        _changeContent(baseProductData.Data, {});
      }
    }

    function getCurrentSelection() {
      var selection = [];
      variants.each(function () {
        var input = $(this);
        var value = input.val();
        var key = input.attr('data-key');
        selection.push({ key: key, value: value });
      });
      return selection;
    }

    function variantMatchingSelection(selection) {
      var variant = firstOrDefault(data, function (v) {
        return all(selection, function (x) {
          return v.VariantKeyValues[x.key] === x.value;
        });
      });
      return variant;
    }

    function allKeys() {
      return select(variants, function (x) {
        return $(x).attr("data-key");
      });
    }

    // change
    variants.on('change', function () {
      var input = $(this);
      _update(input.attr('data-key'), input.val(), true, false);
    });

    /* ITERATOR FUNCTIONS */
    function select(arr, func) {
      var result = [];
      for (var i = 0; i < arr.length; i++) {
        result.push(func(arr[i]));
      }
      return result;
    }

    function firstOrDefault(arr, func) {
      for (var i = 0; i < arr.length; i++) {
        if (func(arr[i])) {
          return arr[i];
        }
      }
      return null;
    }

    function all(arr, func) {
      for (var i = 0; i < arr.length; i++) {
        if (!func(arr[i])) {
          return false;
        }
      }
      return true;
    }

    function defined(value) {
      return value !== '' && value !== null && value !== undefined;
    }

    return {
      hasVariants: true,
      getCurrentSelection: getCurrentSelection,
      variantMatchingSelection: variantMatchingSelection,
      defined: defined
    }
  },

  deliveryInfo: function () {

    var deliveryInfoLinkClass = 'js-product-delivery-information-open';

    $('.' + deliveryInfoLinkClass + ':not(' + deliveryInfoLinkClass + '-done').each(function () {

      var target = $(this);
      var tabTarget = $('.m-tabs__menu__link[href="' + target.attr('href') + '"]');

      target.addClass(deliveryInfoLinkClass + '-done');

      target.off('click').on('click', function () {

        tabTarget.trigger('click');
        $('html, body').animate({ scrollTop: tabTarget.offset().top }, 500);

        return false;

      });

    });

  }

};

$(window).load(function () {
  product.preInit();
  $(document).ajaxComplete(function () {
    product.init();
  });
});
